function hashStringToSeed(str: string) {
	let h = 0x811c9dc5 // FNV offset basis
	for (let i = 0; i < str.length; i++) {
		h ^= str.charCodeAt(i)
		h = Math.imul(h, 0x01000193) // FNV prime
	}
	// Force to unsigned 32‑bit, avoid zero
	return h >>> 0 || 0x9e3779b9
}

export const useSeededRandom = (seedStr: string) => {
	const seed = hashStringToSeed(seedStr)
	// Force to 32‑bit unsigned, avoid all‑zero seed
	let s = seed >>> 0 || 0x9e3779b9

	function nextInt() {
		// xorshift32
		s ^= s << 13
		s ^= s >>> 17
		s ^= s << 5
		// Force back to 32‑bit unsigned
		return s >>> 0
	}

	function next() {
		// Convert to [0, 1) like Math.random()
		return nextInt() / 0x100000000
	}

	return { next, nextInt }
}
